import { Component } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';
import { ModalNotificationImageDirective } from '../../image/modal-notification-image.directive';

@Component({
  imports: [
    TranslateDirective,
    NgxTranslatePipe,
    ModalNotificationImageDirective
  ],
  selector: 'td-wb-modal-notification-recurring-transfers',
  templateUrl: 'modal-notification-recurring-transfers.component.html',
  styleUrls: [
    '../modal-notification-common.component.scss',
    'modal-notification-recurring-transfers.component.scss'
  ]
})
export class ModalNotificationRecurringTransfersComponent {
}
